import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { slugToTypeName, slugToCityName, typeLocationPath } from '@/constants/geo';

const safeDecode = (s?: string) => {
  if (!s) return '';
  try { return decodeURIComponent(s); } catch { return s; }
};

const ensureSlash = (p: string) => (p.endsWith('/') ? p : `${p}/`);

const isKnownRegion = (s: string) => s === 'דרום' || s === 'מרכז';

const LegacyHierRedirect: React.FC = () => {
  const { region = '', city = '', type = '' } =
    useParams<{ region?: string; city?: string; type?: string }>();

  useEffect(() => {
    try {
      const regionDecoded = safeDecode(region);
      const cityDecoded = safeDecode(city);
      const typeDecoded = safeDecode(type);

      const eventType = typeDecoded ? slugToTypeName(typeDecoded) : 'אירוע';
      if (!eventType) {
        window.location.replace('/');
        return;
      }

      if (!cityDecoded) {
        const reg = regionDecoded.replace(/-/g, ' ').trim();
        if (!isKnownRegion(reg)) {
          window.location.replace('/');
          return;
        }
        const dest = ensureSlash(`/תקליטן/${eventType}/${reg}`);
        window.location.replace(dest);
        return;
      }

      const cityName = slugToCityName(cityDecoded);
      if (!cityName) {
        window.location.replace('/');
        return;
      }

      const dest = ensureSlash(typeLocationPath(eventType, cityName));
      window.location.replace(dest);
    } catch {
      window.location.replace('/');
    }
  }, [region, city, type]);

  return null;
};

export default LegacyHierRedirect;